import React, { memo, useEffect, useState } from 'react';
import cx from 'classnames';

const styles = require('./index.less');

/**
 * 样式前缀, 方便外部修改
 * @type {string}
 */
const prefix = 'c-common-loading';

/**
 * 通用 loading
 * @param {number} delayShow - 延迟展示, 默认值为:300, 单位: ms
 * @returns {JSX.Element}
 * @constructor
 */
const CommonLoading = ({ delayShow }) => {
  const [isFadeInEnable, setFadeInEnable] = useState(false);
  useEffect(() => {
    const timeoutHook = setTimeout(() => {
      setFadeInEnable(true);
    }, delayShow);
    return () => {
      clearTimeout(timeoutHook);
    };
  }, []);
  return (
    <div className={cx(styles.root, isFadeInEnable && styles.fadeIn)}>
      <div className={styles.spinner}>
        <div className={cx(`${prefix}-item1`, styles.item)} />
        <div className={cx(`${prefix}-item2`, styles.item, styles.item2)} />
        <div className={cx(`${prefix}-item3`, styles.item, styles.item3)} />
        <div className={cx(`${prefix}-item4`, styles.item, styles.item4)} />
        <div className={cx(`${prefix}-item5`, styles.item, styles.item5)} />
      </div>
    </div>
  );
};

CommonLoading.defaultProps = {
  delayShow: 300
};

export default memo(CommonLoading);
